// @Version: 1.0.0
import { Component, forwardRef, Input, OnDestroy} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs';
import { COLOR, IFieldItem, POSITION } from '../field-item.model';

@Component({
   selector: 'app-field-item-title-one',
   templateUrl: './title-one.component.html',
   providers: [
      {
         provide: NG_VALUE_ACCESSOR,
         multi: true,
         useExisting: forwardRef(() => FieldItemTitleOneComponent)
      }
   ],
   standalone: false
})

export class FieldItemTitleOneComponent implements ControlValueAccessor, OnDestroy {

   public COLOR = COLOR;
   public POSITION = POSITION;

   public smallAndBelow$!: Observable<boolean>;

   private fieldItem_: IFieldItem = {} as IFieldItem;

   @Input() 
   set fieldItem (value: IFieldItem) {
      this.fieldItem_ = value || {};
   }
   get fieldItem (): IFieldItem {
     return this.fieldItem_;
   }

   constructor () { }

   ngOnInit (): void {
   }

   ngOnDestroy (): void {
      this.fieldItem_ = {} as IFieldItem;
   }

   writeValue (obj: any): void {}
   registerOnChange (fn: any): void {}
   registerOnTouched (fn: any): void {}
   setDisabledState (isDisabled: boolean | undefined): void {}
}